import React from 'react';
import { connect } from 'react-redux';
import * as ReportPortalActions from '../../../Actions/ReportPortalActions';
import RecruiterByJobReports from '../../../Components/ReportPortal/ReportStatsTab/RecruiterByJobReports/RecruiterByJobReports';
import { getApiStatus } from '../../../Reducers/ApiStatusReducer';
import { getReportColumns as _getReportColumns, getReportStats } from '../../../Reducers/ReportPortalReducer';

const componentKey = 'recruitersbyjob';

const mapStateToProps = state => {
  return {
    fetchReportStatsApiStatus: getApiStatus(state, 'fetchReportStatsApiStatus'),
    exportReportApiStatus: getApiStatus(state, 'exportReportApiStatus'),
    reportStats: getReportStats(state, componentKey),
    reportColumns: _getReportColumns(state, componentKey),
  };
};

const mapDispatchToProps = {
  fetchReportStats: ReportPortalActions.getReportStats,
  generateReport: ReportPortalActions.generateReport,
  clearReportStats: ReportPortalActions.clearReportStats,
  getReportColumns: ReportPortalActions.getReportColumns,
  clearFetchReportStatsApiStatus: ReportPortalActions.clearFetchReportStatsApiStatus,
  clearRecruitersForDropdownLists: ReportPortalActions.clearRecruitersForDropdownLists,
  clearClientsForDropdownLists: ReportPortalActions.clearClientsForDropdownLists,
};

export function RecruiterByJobReportsContainer(props) {
  const {
    reportStats,
    fetchReportStats,
    fetchReportStatsApiStatus,
    clearReportStats,
    generateReport,
    exportReportApiStatus,
    clearFetchReportStatsApiStatus,
    savedQueryConfig,
    onSaveQuerySuccess,
    clearRecruitersForDropdownLists,
    clearClientsForDropdownLists,
  } = props;

  return (
    <div>
      <RecruiterByJobReports
        savedQueryConfig={savedQueryConfig}
        onSaveQuerySuccess={onSaveQuerySuccess}
        fetchReportStatsApiStatus={fetchReportStatsApiStatus}
        reportStats={reportStats}
        getReportStats={fetchReportStats}
        clearReportStats={clearReportStats}
        exportReportApiStatus={exportReportApiStatus}
        generateReport={generateReport}
        clearFetchReportStatsApiStatus={clearFetchReportStatsApiStatus}
        clearRecruitersForDropdownLists={clearRecruitersForDropdownLists}
        clearClientsForDropdownLists={clearClientsForDropdownLists}
      />
    </div>
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(RecruiterByJobReportsContainer);
